import { LicenseInfo } from "@mui/x-license-pro";
import { useEffect } from "react";

export default function useGetMUILicense() {

  // AWS MUI License is from AWS Secret Manager
  useEffect(() => {
    LicenseInfo.setLicenseKey(process.env.REACT_APP_AWS_MUI_LICENSE);
  }, []);
}